import { nanoid } from 'nanoid'
import React from 'react'

const Recommendations = () => {
  return (
    <div className='w-[100%] h-[85vh] px-3 rounded-2xl pt-8 bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] flex flex-col justify-center'>
        <p className='text-main-blue'>Recommendations</p>
        <div className='h-[75vh]'>
            {
                recommendationData.map(recommendation => <Recommendation key = {recommendation.id} title={recommendation.title} tag= {recommendation.tag}/>)
            }
        </div>
    </div>
  )
}

export default Recommendations

const Recommendation = ({ title, tag}: {
    title:string,
    tag: string
}) => {
    return(
        <div className='w-[100%] h-[22vh] bg-recommend rounded-lg my-3 flex flex-col justify-end p-2 text-white'>
            <p>{title}</p>
            <p>{tag}</p>
        </div>
    )
}

const recommendationData = [
    {
        id: nanoid(),
        title: "The Ultimate Job Interview",
        tag: "Preparation Guide"
    },
    {
        id: nanoid(),
        title: "The Ultimate Job Interview",
        tag: "Preparation Guide"
    },
    {
        id: nanoid(),
        title: "The Ultimate Job Interview",
        tag: "Preparation Guide"
    }
]